
import * as actionTypes from './actionTypes'
const qs = require('querystring');

export const ON_SORT = 'ON_SORT';
export const ON_PAGINATE = 'ON_PAGINATE';
export const ON_SEARCH = 'ON_SEARCH';

export const onSearch = (payload) => {
    return {
        type: ON_SEARCH,
        payload
    }
}

export const onPaginate = pageNo => {
    return {
        type : ON_PAGINATE,
        pageNo
    }
}

export const onSort = (column, type) => {
    console.log({column, type});
    return {
        type: ON_SORT,
        payload: { column, type }
    }
}

// export const setOffset = (offset) => {
//     return {
//         type: actionTypes.SET_OFFSET,
//         offset
//     }
// }

export const setPlayerTypeList = (playerTypeList) => {
    return {
        type:actionTypes.SET_PLAYER_TYPE_LIST,
        playerTypeList
    }
}

export const getPlayerTypeList = () => {
    return {
        type: actionTypes.GET_PLAYER_TYPE_LIST
    }
}

export const setRolesAndBusiness = (roles, business, selectedRoles, selectedBusiness) => {
    return {
        type: actionTypes.SET_ROLES_AND_BUSINESS,
        roles, 
        business, 
        selectedRoles, 
        selectedBusiness
    }
}

export const getRolesAndBusiness = () => {
    return {
        type: actionTypes.GET_ROLES_AND_BUSINESS
    }
}

export const setUsersList = (usersList, totalCount) => {
    return {
        type: actionTypes.SET_USERS_LIST,
        usersList, totalCount
    }
}

export const getUsersList = (request) => {       
    return {
        type: actionTypes.GET_USERS_LIST,
        data: request
    }
}   

export const setCoachList = (coachList) => {
    return {
        type: actionTypes.SET_COACH_LIST,
        coachList
    }
}

export const onRoleChange = (value, roles) => {
    return dispatch => {
        let selectedRoles = []
        if(value.indexOf('All') !== -1) selectedRoles = roles.map(function(id) { return id._id })
        else selectedRoles = value
        dispatch({type: actionTypes.ON_ROLE_CHANGE, selectedRoles})
    }
}

export const onBussChange = (value, business) => {
    return dispatch => {
        let selectedBusiness = []
        if(value.indexOf('All') !== -1) selectedBusiness = business.map(function(id) { return id._id })
        else selectedBusiness = value
        dispatch({type: actionTypes.ON_BUSINESS_CHANGE, selectedBusiness})
    }
}




/** WEBPACK FOOTER **
 ** ./src/store/actions/appUserAction.js
 **/